import { render } from "./SudAmericaView.vue?vue&type=template&id=75bdc820"
import script from "./SudAmericaView.vue?vue&type=script&lang=js"
export * from "./SudAmericaView.vue?vue&type=script&lang=js"

import "./SudAmericaView.vue?vue&type=style&index=0&id=75bdc820&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__